<template>
  <div class="sp_personalCenter">
    <heade-title :title="title"></heade-title>
    <div class="content">
      <el-form :model="userFrom"
               ref="userFrom"
               :rules="uesrRules"
               class="userFrom">
        <!-- 公司信息开始 -->
        <div class="sp_inforTitle"><span></span>
          <p>Company Information</p>
        </div>
        <div class="company-info flex-box">
          <el-form-item class="company-item item-content"
                        label="Company Name："
                        prop="companyName">
            <el-input :disabled="userInfo.roleId!=='1'"
                      size="small"
                      v-model="userFrom.companyName"
                      placeholder="Please input company name"></el-input>
          </el-form-item>
          <el-form-item class="company-item sp_telSelect item-content"
                        label="Tel："
                        prop="companyPhone">
            <el-input :disabled="userInfo.roleId!=='1'"
                      type="number"
                      size="small"
                      class="input-with-select"
                      v-model="userFrom.companyPhone"
                      placeholder="Please input the phone number.">
              <el-select :disabled="userInfo.roleId!=='1'"
                         filterable
                         no-match-text="No Data"
                         remote
                         :remote-method="remoteMethod"
                         @visible-change="areaCodeFocus"
                         v-model="userFrom.companyAreaCode"
                         slot="prepend"
                         placeholder="Code">
                <el-option :label="val.areaCode"
                           :value="val.id"
                           v-for="val in areaCodelist"
                           :key="val.id">{{val.country+' '+val.areaCode}}</el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item class="company-item item-content"
                        label="Industry：">
            <el-cascader :disabled="userInfo.roleId!=='1'"
                         clearable
                         size="small"
                         style="width:100%;"
                         v-model="userFrom.industry"
                         placeholder="Please select industry."
                         :options="filterIndustryList"
                         :props="industryProps"></el-cascader>
          </el-form-item>
        </div>
        <div class="address-info flex-box">
          <el-form-item label="Country/Region："
                        prop="region"
                        class="item-content">
            <el-select filterable
                       style="width:100%;"
                       size="small"
                       v-model="userFrom.region"
                       placeholder="Please select country/region."
                       :disabled="true">
              <el-option :label="val.name"
                         :key="val.value"
                         v-for="val in countryList"
                         :value="{value:val.value,name:val.name}"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="State："
                        prop="state："
                        class="item-content">
            <el-select filterable
                       style="width:100%;"
                       size="small"
                       v-model="userFrom.state"
                       placeholder="Please select state."
                       @change="changeState"
                       :disabled="adminId !== '1'">
              <el-option :label="val.name"
                         :key="val.id"
                         v-for="val in stateList"
                         :value="{value:val.id,name:val.name}"></el-option>

            </el-select>
          </el-form-item>
          <el-form-item label="City："
                        prop="city"
                        class="item-content">
            <el-select filterable
                       style="width:100%;"
                       v-model="userFrom.city"
                       size="small"
                       placeholder="Please select City."
                       :disabled="adminId !== '1'">
              <el-option :label="val.name"
                         :key="val.id"
                         v-for="val in cityList"
                         :value="{value:val.id,name:val.name}"></el-option>

            </el-select>
          </el-form-item>

          <el-form-item label="Address："
                        prop="address"
                        class="item-content">
            <el-input type="text"
                      size="small"
                      v-model="userFrom.address"
                      placeholder="Please input address."
                      :disabled="userInfo.roleId!=='1'"></el-input>
          </el-form-item>

          <el-form-item class="company-item item-content"
                        label="Admin Email："
                        prop="companyInfoEmail">
            <el-input :disabled="true"
                      size="small"
                      v-model="userFrom.companyInfoEmail"
                      placeholder="Please input admin email"></el-input>
          </el-form-item>
        </div>
        <!-- 公司信息结束 -->
        <!-- 个人信息开始 -->
        <div class="sp_inforTitle personal-info-title"><span></span>
          <p>Personal Information</p>
        </div>
        <div class="user-info flex-box">
          <el-form-item label="First Name："
                        prop="firstname"
                        class="item-content">
            <el-input size="small"
                      type="text"
                      placeholder="Please input first name"
                      v-model="userFrom.firstname"></el-input>
          </el-form-item>
          <el-form-item label="Last Name："
                        prop="lastname"
                        class="item-content">
            <el-input size="small"
                      type="text"
                      placeholder="Please input last name"
                      v-model="userFrom.lastname"></el-input>
          </el-form-item>
          <el-form-item label="Tel："
                        class="sp_telSelect item-content"
                        prop="phone">
            <el-input type="number"
                      size="small"
                      v-model="userFrom.phone"
                      class="input-with-select"
                      placeholder="Please input the phone number.">
              <el-select filterable
                         no-match-text="No Data"
                         remote
                         :remote-method="remoteMethod"
                         @visible-change="areaCodeFocus"
                         v-model="userFrom.areaCode"
                         slot="prepend"
                         placeholder="Code">
                <el-option :label="val.areaCode"
                           :value="val.id"
                           v-for="val in areaCodelist"
                           :key="val.id">{{val.country+' '+val.areaCode}}</el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="Email："
                        prop="personalInfoEmail"
                        class="item-content">
            <el-input size="small"
                      :disabled="true"
                      type="text"
                      placeholder="Please input email"
                      v-model="userFrom.personalInfoEmail"></el-input>
          </el-form-item>
        </div>
        <!-- 个人信息结束 -->
        <div class="footer-line"></div>
        <!-- 按钮区域开始 -->
        <div class="footer">

          <el-button type="primary"
                     size="medium"
                     class="save-btn btn"
                     :loading="saveLoading"
                     @click="handleSave('userFrom')">Save</el-button>
          <el-button plain
                     size="medium"
                     class="cancel-btn btn"
                     @click="handleback">Cancel</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  getCountry,
  getIndustry,
  getAreaCode,
  getStatesByGSMCountryId,
  getCity,
} from '@/api/loginApi.js'
import {
  checkCompanyNameApi,
  getCompanyInforApi,
  updatePersonalCenterApi,
} from '@/api/common.js'
import headeTitle from '../../components/headeTitle.vue'
export default {
  components: { headeTitle },
  name: 'personalCenter',
  data() {
    var checkCompanyName = (rule, value, callback) => {
      const Reg =
        /^[a-zA-Z0-9'‐_.,:;\[\]{}()（）﹙﹚《》﹝﹞%+*!?\-@#$/=&°|、’‚–\t“”\" ]{1,200}$/
      if (!value) {
        return callback(new Error('Please input company name.'))
      } else {
        if (Reg.test(value)) {
          checkCompanyNameApi(value).then((res) => {
            if (res.code == 0) {
              return callback()
            } else if (res.code == 500) {
              return callback(new Error(res.msg))
            }
          })
        } else {
          this.$message.error(
              'Cannot exceed over 200 characters and only supports English,digits and these specail characters: -_.,:;[]{}()（）《》﹝﹞%+*!?@#$=&|°、’‚–“”"' +
                "'")
          return callback(
            new Error()
          )
        }
      }
    }
    var companyPhone = (rule, value, callback) => {
      if (value && this.userFrom.companyAreaCode !== '') {
        if (value.length > 255) {
          return callback(new Error('Cannot exceed over 255 characters.'))
        } else {
          return callback()
        }
      } else {
        return callback(new Error('Please input the phone number.'))
      }
    }
    var checkAddress = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input address.'))
      } else {
        if (value.length > 1000) {
          return callback(new Error('Cannot exceed over 1000 characters.'))
        } else {
          return callback()
        }
      }
    }
    var checkPhone = (rule, value, callback) => {
      if (value && this.userFrom.areaCode !== '') {
        if (value.length > 255) {
          return callback(new Error('Cannot exceed over 255 characters.'))
        } else {
          return callback()
        }
      } else {
        return callback(new Error('Please input the phone number.'))
      }
    }
    var checkfirstName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input first name.'))
      } else {
        if (value.length > 255) {
          return callback(new Error('Cannot exceed over 255 characters.'))
        } else {
          return callback()
        }
      }
    }
    var checklastName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input last name.'))
      } else {
        if (value.length > 255) {
          return callback(new Error('Cannot exceed over 255 characters.'))
        } else {
          return callback()
        }
      }
    }
    return {
      title: 'Personal Center',
      userFrom: {
        companyName: '',
        companyPhone: '',
        companyAreaCode: '',
        industry: '',
        address: '',
        firstname: '',
        lastname: '',
        email: '',
        personalInfoEmail: '',
        companyInfoEmail: '',
        region: {},
        state: {},
        city: {},
        phone: '',
        areaCode: '',
      },
      uesrRules: {
        companyName: [
          { required: true, validator: checkCompanyName, trigger: 'blur' },
        ],
        companyPhone: [
          { required: true, validator: companyPhone, trigger: ['blur'] },
        ],
        address: [{ required: true, validator: checkAddress, trigger: 'blur' }],
        region: [
          {
            required: true,
            message: 'Please select country/region.',
            trigger: 'change',
          },
        ],
        firstname: [
          { required: true, validator: checkfirstName, trigger: 'blur' },
        ],
        lastname: [
          { required: true, validator: checklastName, trigger: 'blur' },
        ],
        phone: [{ required: true, validator: checkPhone, trigger: ['blur'] }],
      },
      areaCodelist: [],
      companyAreaCode: [],
      industryList: [],
      countryList: [],
      stateList: [],
      cityList: [],
      industryList: [],
      industryProps: {
        value: 'id',
        label: 'name',
        children: 'list',
      },
      companyInfo: {},
      userInfo: {},
      saveLoading: false,
    }
  },

  methods: {
    //获取国家电话区号列表
    getAreaCodeList() {
      getAreaCode().then((res) => {
        this.areaCodelist = res.rows
        this.$ls.set('AreaCode', res.rows)
      })
    },

    //获取行业列表
    getIndustryInfo() {
      getIndustry('customer_business').then((res) => {
        this.industryList = res.rows
        this.$ls.set('industry', res.rows)
      })
    },

    //获取国家列表
    getCountryList() {
      getCountry('country').then((res) => {
        this.countryList = res.rows
        this.$ls.set('country', res.rows)
      })
    },

    //过滤空的industry
    filterIndustry(data) {
      data.map((val) => {
        if (val.list && val.list.length > 0) {
          this.filterIndustry(val.list)
        } else {
          delete val.list
        }
      })
      return data
    },

    //电话区号搜索
    remoteMethod(qurey) {
      this.areaCodelist = this.areaCodelist.filter((val) => {
        if (
          (val.country + ' ' + val.areaCode)
            .toLowerCase()
            .replace(/\s/g, '')
            .indexOf(qurey.toLowerCase().replace(/\s/g, '')) != -1
        ) {
          return true
        }
        return false
      })
    },
    areaCodeFocus(qurey) {
      setTimeout(() => {
        if (!qurey) {
          this.areaCodelist = this.$ls.get('AreaCode')
        }
      }, 200)
    },

    //返回上一页
    handleback() {
      this.$router.back()
    },

    //获取公司信息
    getCompanyInfor() {
      let params = this.$store.getters.userInfo.corpsId
      getCompanyInforApi(params).then((res) => {
        let companyInfo = res.rows
        this.userFrom.companyName = companyInfo.name
        this.userFrom.companyPhone = companyInfo.phone
          ? companyInfo.phone.replace(/\s/g, '')
          : ''
        this.userFrom.companyInfoEmail = companyInfo.companyInfoEmail
        this.userFrom.companyAreaCode = companyInfo.areaCode
        this.userFrom.companyAreaCode = companyInfo.areaCode
        this.userFrom.industry = companyInfo.industry
          ? companyInfo.industry.split(',')
          : []
        this.userFrom.address = companyInfo.address
        this.userFrom.region.value = companyInfo.region
        this.userFrom.region.name = companyInfo.countryName
        this.userFrom.state.value = companyInfo.statesId || ''
        this.userFrom.state.name = companyInfo.statesName || ''
        this.userFrom.city.value = companyInfo.cityId || ''
        this.userFrom.city.name = companyInfo.cityName || ''

        this.getStateList()

        if (companyInfo.cityId) {
          this.getCityList()
        }
      })
    },
    changeState() {
      this.getCityList()
      this.userFrom.city = {}
    },
    //获取一级行政区
    getStateList() {
      getStatesByGSMCountryId(this.userFrom.region.value).then((res) => {
        this.stateList = res.rows
      })
    },
    //获取二级行政区
    getCityList() {
      getCity(this.userFrom.state.value).then((res) => {
        this.cityList = res.rows
      })
    },
    //修改个人中心信息
    handleSave(userFrom) {
      this.$refs[userFrom].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          let params = JSON.parse(JSON.stringify(this.userFrom))

          params.region = this.userFrom.region.value //国家id
          params.countryName = this.userFrom.region.name //国家名称
          params.statesId = this.userFrom.state.value //一级行政区id
          params.statesName = this.userFrom.state.name //一级行政区名称
          params.cityId = this.userFrom.city.value //二级行政区id
          params.cityName = this.userFrom.city.name //二级行政区名称

          delete params.state
          delete params.city

          params.industry = params.industry ? params.industry.join(',') : ''
          updatePersonalCenterApi(params)
            .then((res) => {
              this.saveLoading = false
              this.$message({
                type: 'success',
                message: 'Save successfully',
              })
              this.getCompanyInfor()
              this.$store.dispatch('GetUserInfo')
            })
            .catch(() => {
              this.saveLoading = false
            })
        }
      })
    },
  },

  created() {
    this.userInfo = this.$store.getters.userInfo
    this.userFrom.firstname = this.userInfo.firstName
    this.userFrom.lastname = this.userInfo.lastName
    this.userFrom.personalInfoEmail = this.userInfo.email
    this.userFrom.phone = this.userInfo.phone
      ? this.userInfo.phone.replace(/\s/g, '')
      : ''
    this.userFrom.areaCode = this.userInfo.areaCode
    this.getAreaCodeList()
    this.getIndustryInfo()
    this.getCountryList()
    this.getCompanyInfor()
  },

  computed: {
    filterIndustryList() {
      return this.filterIndustry(this.industryList)
    },

    adminId() {
      return this.$store.state.user.userInfo.roleId
    },
  },
}
</script>

<style lang="scss" scoped>
.sp_personalCenter {
  width: 100%;
  min-height: 100%;
  background: #ffffff;
  .content {
    padding: 16px;
  }
  /deep/.el-card__body {
    padding: 16px !important;
  }
  @media screen and (max-width: 1366px) {
    .flex-box {
      display: flex;
      flex-wrap: wrap;
      min-width: 1038px;
      overflow: auto;
      .item-content {
        max-width: 400px;
        min-width: 400px;
        margin-right: 48px;
        flex: 0 0 50%;
      }
    }
  }
  .userFrom {
    width: 100%;
    padding: 16px 20px;
    box-sizing: border-box;
    .sp_inforTitle {
      width: 100%;
      font-size: 14px;
      color: #13161a;
      height: 32px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      span {
        width: 4px;
        height: 14px;
        background: #2684ff;
        margin-right: 8px;
        margin-left: -12px;
      }
      p {
        font-size: 18px;
        color: #13161a;
        font-weight: 500;
      }
    }
    .personal-info-title {
      margin-top: 8px;
    }
    .company-info {
      margin-top: 8px;
    }
    .flex-box {
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        margin-bottom: 16px;
      }
      .item-content {
        max-width: 400px;
        min-width: 400px;
        margin-right: 48px;
        flex: 0 0 33.33%;

        /deep/.el-form-item__label {
          height: 20px;
          line-height: 20px;
          margin-bottom: 4px;
          font-size: 14px;
          color: #545c66;
        }
        /deep/.el-form-item__content {
          line-height: 32px;
        }
      }
    }
    .footer-line {
      margin: 0 -20px 16px;
      border-bottom: 1px solid #e9edf2;
    }
    .save-btn {
      margin-left: -12px;
    }
    .btn {
      height: 36px;
    }
    /deep/.el-select {
      .el-select__caret:first-child::before {
        content: '\e6e1';
      }
      .is-focus {
        .el-select__caret:first-child {
          transform: rotateZ(0deg);
        }
      }
    }
    /deep/.input-with-select input::-webkit-outer-spin-button,
    /deep/.input-with-select input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    /deep/ .input-with-select input[type='number'] {
      -moz-appearance: textfield;
    }
  }
}
/deep/.el-input-group__prepend {
  width: 22%;
  background: #fff !important;
}
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
/deep/.el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  margin-left: -10px !important;
}
</style>